import React from 'react';
import PropTypes from 'prop-types';

import Button from 'partial/components/Button';
import { ModalCard, useCreateModal } from 'partial/components/Modal';

import { VscDebugDisconnect } from 'react-icons/vsc';
import { useRegenerateApiKey } from '../hooks';

export const useShowRegenerateApiKeyModal = () => {
  const createModal = useCreateModal('REGENERATE_API_MODAL');
  const openModal = React.useCallback(
    (data) => {
      createModal({
        content: (onClose) => (
          <ModalCard
            title="Confirm Key Regeneration"
            size="sm"
            onClose={onClose}
          >
            <RegenerateApiKeyModal onClose={onClose} data={data} />
          </ModalCard>
        ),
      });
    },
    [createModal]
  );
  return [openModal];
};

function RegenerateApiKeyModal({ onClose, data }) {
  const [isRegenerating, regenerate] = useRegenerateApiKey();

  const handleRegenerate = () => {
    regenerate(data?.merchant_id, data?.api_key_id);
    onClose();
  };

  return (
    <div className="flex flex-col space-y-6 px-8 py-8">
      <div className="flex items-center">
        <div className="space-y-4">
          <h2 className="text-lg font-light">
            Are you sure you want to{' '}
            <span className="font-semibold">regenerate new key</span>?
          </h2>
          <p>
            If you continue, the old token key will be replaced with a new one.
            This can&apos;t be undone.
          </p>
        </div>
        <div>
          <VscDebugDisconnect className="h-16 w-16 rounded-2xl p-2 flex-shrink-0 text-primary-700 border-4 border-primary-700 bg-primary-100" />
        </div>
      </div>

      <div className="flex justify-center">
        <Button
          size="xl"
          className="mr-2"
          onClick={onClose}
          disabled={isRegenerating}
        >
          Close
        </Button>
        <Button
          primary
          size="xl"
          onClick={handleRegenerate}
          disabled={isRegenerating}
        >
          Confirm
        </Button>
      </div>
    </div>
  );
}

RegenerateApiKeyModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RegenerateApiKeyModal;
